import React from 'react';
import { Spacing } from '_styles';

// title and subtitle in row on booking card
const BookingRowItem = (props) => {
  return (
    <>
      <div>
        <p style={{ fontWeight: 'bold', opacity: 0.6 }}>{props.title}</p>
        <p style={{ fontWeight: '300', marginTop: -Spacing.SCALE_12 }}>{props.subtitle}</p>
      </div>
    </>
  );
};


export default BookingRowItem;
